import { chakra } from "@chakra-ui/system"
import { Link as RouterLink } from "preact-router"

export const Link = chakra(RouterLink)
